import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsCustomObjectTypeRelationships = "/custom_objects/custom_object_type_relationships";

export const customObjectsCustomObjectTypeRelationshipsCacheKeys: AllRouteEndpoints[] = [
  "/custom_objects/custom_object_type_relationships",
];
